import React from 'react';
import { artistStatement, researchStatement } from '../mock';

const Research = () => {
  return (
    <div className="min-h-screen bg-off-white py-20 px-6">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-4xl md:text-5xl font-bold text-charcoal mb-12">
          Research & Statements
        </h1>

        {/* Artist Statement */}
        <section className="mb-16">
          <h2 className="text-2xl md:text-3xl font-bold text-charcoal mb-6 pb-3 border-b-2 border-copper">
            Artist Statement
          </h2>
          <div className="prose prose-lg max-w-none">
            {artistStatement.split('\n\n').map((paragraph, index) => (
              <p key={index} className="text-neutral-700 leading-relaxed mb-6">
                {paragraph}
              </p>
            ))}
          </div>
        </section>

        {/* Research Statement */}
        <section>
          <h2 className="text-2xl md:text-3xl font-bold text-charcoal mb-6 pb-3 border-b-2 border-copper">
            Research Statement
          </h2>
          <div className="prose prose-lg max-w-none">
            {researchStatement.split('\n\n').map((paragraph, index) => (
              <p key={index} className="text-neutral-700 leading-relaxed mb-6">
                {paragraph}
              </p>
            ))}
          </div>
        </section>

        {/* Key Concepts */}
        <section className="mt-16 bg-warm-grey p-8 rounded-lg">
          <h3 className="text-xl font-semibold text-charcoal mb-4">Key Research Areas</h3>
          <div className="grid md:grid-cols-2 gap-4">
            <div className="flex items-start">
              <span className="text-copper font-bold mr-3">•</span>
              <span className="text-neutral-700">ADOS Identity & Black Native Experience</span>
            </div>
            <div className="flex items-start">
              <span className="text-copper font-bold mr-3">•</span>
              <span className="text-neutral-700">Wake Work & Christina Sharpe's Framework</span>
            </div>
            <div className="flex items-start">
              <span className="text-copper font-bold mr-3">•</span>
              <span className="text-neutral-700">Memory, History & Ancestry</span>
            </div>
            <div className="flex items-start">
              <span className="text-copper font-bold mr-3">•</span>
              <span className="text-neutral-700">Material Residency Time</span>
            </div>
            <div className="flex items-start">
              <span className="text-copper font-bold mr-3">•</span>
              <span className="text-neutral-700">Performance & Embodied Practice</span>
            </div>
            <div className="flex items-start">
              <span className="text-copper font-bold mr-3">•</span>
              <span className="text-neutral-700">Technology & Digital Fabrication</span>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Research;